import React, { useState } from "react";
import "./clientReview.css"; // Import CSS file for styling

function ClientReview() {
  const [hoverIndex, setHoverIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  const quotes = [
    {
      text: "Stannum made my dream of working in Dubai a reality! Their team guided me through the entire visa process with such professionalism and care. They ensured all my documents were in order and kept me informed at every step. Highly recommend them to anyone looking for reliable visa consultancy!",
      author: "Maria Fernandes",
      company: "Dubai",
    },
    {
      text: "I was initially overwhelmed by the complexities of the Dubai work visa process, but Stannum took away all my worries. From assisting with paperwork to offering valuable career advice, they went above and beyond to ensure I had a successful application. Thanks to them, I’m now settled in my new job in Dubai.",
      author: "Ahmed Khan",
      company: "Dubai",
    },
    {
      text: "Stannum is hands down the best consultancy for work visas to Dubai! Their team is knowledgeable, efficient, and approachable. They made sure my application was flawless and kept me updated throughout the process. I highly recommend their services!",
      author: "Priya Sharma",
      company: "Dubai",
    },
  ];

  return (
    <div className="clientReview-container">
        <div
            className="clientReview-title"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            <h1 className="clientReview-title-h1">Our Happy Clients</h1>
        </div>
      <div className="clientReview-content"
        data-aos="zoom-in"
        data-aos-duration="1000"
      >
        {quotes.map((quote, index) => (
            <figure
            className={`clientReview ${hoverIndex === index ? "hover" : ""}`}
            key={index}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            >
            <figcaption>
                <blockquote>
                <p>{quote.text}</p>
                </blockquote>
                <h3>{quote.author}</h3>
                <h4>{quote.company}</h4>
            </figcaption>
            </figure>
        ))}
      </div>
    </div>
  );
}

export default ClientReview;
